<button
  class="rooms button dropdown button--style-white-04 h-32 rounded-6 padding-x-8"
  [cdkMenuTriggerFor]="menu"
>
  <img
    class="country flex items-center justify-center s-16 icon--radius-full"
    [src]="currentRoom().image"
  />
  <span class="room-name flex items-center">
    {{ currentRoom().name }}
  </span>
  <div class="room-count flex items-center">
    <span class="tf2hunt--lightning dot"></span>
    {{ count() }}
  </div>
  <svg-icon
    class="flex items-center justify-center s-16 indicator"
    src="assets/icons/ui/arrow.svg"
  />
</button>
<ng-template #menu>
  <div class="rooms-menu flex flex-col" cdkMenu>
    @for (room of rooms(); track room.id) {
    <button
      cdkMenuItemRadio
      class="rooms-menu--item flex items-center"
      [cdkMenuItemChecked]="currentRoom().id === room.id"
      (cdkMenuItemTriggered)="changeCurrentRoom.emit(room.id)"
    >
      <img
        class="flex items-center justify-center s-16 icon--radius-full"
        [src]="room.image"
      />
      {{ room.name }}
    </button>
    }
  </div>
</ng-template>
